import styled from 'styled-components'

export default styled.span`
  font-size: 75%;
  color: ${props => props.theme.colors.grey};
`
